var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"link",class:{ disabled: !_vm.link.length },attrs:{"href":_vm.link}},[(_vm.icon.length)?_c('div',{staticClass:"link__icon d-flex",domProps:{"innerHTML":_vm._s(require(`@/assets/img/icons/${_vm.icon}.svg`))}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }